import { useEffect, useRef } from 'react';

export default function AdUnit({ format = "horizontal", className = "" }) {
  const adRef = useRef(null);
  const adClient = process.env.REACT_APP_ADSENSE_CLIENT_ID || "";
  
  // Show placeholder if no AdSense ID configured or not in production
  const showPlaceholder = !adClient || adClient === "ca-pub-XXXXXXXXXX" || process.env.NODE_ENV !== 'production';
  
  useEffect(() => {
    // Only load AdSense if we have a valid client ID and we're in production
    if (!showPlaceholder) {
      // Load AdSense script if not already loaded
      if (!window.adsbygoogle) {
        const script = document.createElement('script');
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adClient}`;
        script.async = true;
        script.crossOrigin = "anonymous";
        document.head.appendChild(script);
      }

      // Push ad after script loads
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (err) {
        console.error('AdSense error:', err);
      }
    }
  }, [adClient, showPlaceholder]);
  
  return (
    <aside
      ref={adRef}
      className={`ad-unit ${className} flex items-center justify-center bg-slate-50 border border-slate-200 rounded-lg overflow-hidden`}
      style={{ 
        minHeight: format === 'leaderboard' ? '90px' : (format === 'horizontal' ? '90px' : '250px'),
        width: '100%',
        minWidth: '300px'
      }}
      data-testid={`ad-unit-${format}`}
      aria-label="Advertisement"
    >
      {showPlaceholder ? (
        <div className="text-center p-4">
          <span className="label-mono text-slate-400 text-xs">ADVERTISEMENT</span>
        </div>
      ) : (
        <ins 
          className="adsbygoogle"
          style={{ display: 'block', width: '100%', height: '100%', minHeight: '90px' }}
          data-ad-client={adClient}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      )}
    </aside>
  );
}
